import {Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {HighlightCategory} from '__generated__/__types__';
import React from 'react';
import {Scrollbar} from 'swiper/modules';
import HighLightCategory from './highlight-category.desktop';

export interface HighlightCategoriesProps {
    highlightCategories?: HighlightCategory[];
}

const PopularCatalog: React.FC<HighlightCategoriesProps> = ({highlightCategories = []}) => {
    if (!highlightCategories.length) {
        return null;
    }

    return (
        <div className="w-full">
            <div className="flex flex-col content-center justify-center rounded-2xl bg-white px-[22px] py-5">
                <h2 className="mb-5 text-[22px] font-extrabold leading-[25px] text-primary">Danh mục nổi bật</h2>
                <div>
                    <Swiper
                        className="!pb-8"
                        direction="horizontal"
                        scrollbar={{
                            el: '.swiper-scrollbar',
                            draggable: true,
                            dragSize: 'auto',
                        }}
                        modules={[Scrollbar]}
                        breakpoints={{
                            1280: {
                                slidesPerView: 8.5,
                                spaceBetween: 30,
                            },
                            1024: {
                                slidesPerView: 6.5,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 4.5,
                                spaceBetween: 10,
                            },
                        }}>
                        {highlightCategories.map(item => (
                            <SwiperSlide key={item?.url}>
                                <HighLightCategory category={item as HighlightCategory} />
                            </SwiperSlide>
                        ))}

                        <div className="block">
                            <div className="swiper-scrollbar"></div>
                        </div>
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default PopularCatalog;
